// src/components/ProTrialBanner.tsx
// Pro Trial banner — shown to basic-tier users, dismissible
// Offer: Free for 7 days, then ₹199/$10 per month

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { trackProBannerClicked } from '../utils/analytics';

interface ProTrialBannerProps {
  onClose: () => void;
}

const ProTrialBanner: React.FC<ProTrialBannerProps> = ({ onClose }) => {
  const navigate = useNavigate();

  return (
    <div className="fixed top-20 right-4 z-40 max-w-sm animate-slide-in-right">
      <div className="bg-gradient-to-br from-purple-600 to-pink-600 rounded-2xl shadow-2xl p-5 text-white border border-purple-400/30">
        <div className="flex items-start justify-between mb-2">
          <div className="flex items-center gap-2">
            <span className="text-xl">&#9889;</span>
            <h3 className="font-bold text-base">Try Pro Free for 7 Days</h3>
          </div>
          <button
            onClick={onClose}
            className="text-white/70 hover:text-white text-lg leading-none ml-2"
            aria-label="Dismiss"
          >
            &times;
          </button>
        </div>

        <p className="text-sm text-white/90 mb-3 leading-relaxed">
          Unlock unlimited code execution, BookMate tutorials, and Workflow automation for <strong>7 days</strong>.
        </p>

        <ul className="text-xs text-white/85 space-y-1 mb-4">
          <li>&#10003; 200 credits to start</li>
          <li>&#10003; All Pro features unlocked</li>
          <li>&#10003; Cancel anytime &mdash; auto-renews after trial</li>
        </ul>

        <div className="flex gap-2">
          <button
            onClick={() => { trackProBannerClicked(); navigate('/settings?tab=subscription'); }}
            className="flex-1 py-2 px-3 bg-white text-purple-700 rounded-lg text-sm font-semibold hover:bg-white/90 transition-all"
          >
            Start Free Trial
          </button>
          <button
            onClick={onClose}
            className="px-3 py-2 text-white/80 text-xs hover:text-white"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProTrialBanner;
